import React from "react";
import { Box, Typography } from "@mui/material";
import CloseIconButton from "../../../../shared/components/CloseIconButton";
import { AdminStockItem } from "../../../models/AdminStockItemsModels";

interface TitleProps {
  stockItem: AdminStockItem | undefined;
  onClose: () => void;
}

const Title = ({ stockItem, onClose }: TitleProps) => {
  return (
    <Box>
      <Typography fontSize={16} fontWeight={500} className="text-16-medium" style={{ color: "#333" }}>
        {stockItem?.product?.number}
      </Typography>
      <Typography fontSize={14} fontWeight={500} className="text-14-medium">
        {stockItem?.alternativeNumber}
      </Typography>
      <CloseIconButton onClose={onClose} />
    </Box>
  );
};
export default Title;
